<template>
 <div class="conclusion-skeleton pulse">
  <div class="skeleton-card primary-info">
   <div class="title" />
   <div class="message-row pulse" />
   <div class="message-row pulse" />
   <div class="message-row pulse" />
  </div>

  <div class="text-small-row wave" />

  <div class="skeleton-card secondary-info">
   <div class="fake-img" />
   <div class="info-wrapper">
    <div class="info" />
    <div class="info" />
   </div>
  </div>

  <div class="skeleton-card secondary-info">
   <div class="fake-img" />
   <div class="info-wrapper">
    <div class="info" />
    <div class="info" />
   </div>
  </div>
 </div>
</template>

<script>
export default {
  name: 'conclusion-skeleton'
};
</script>

<style lang="scss" scoped>
.conclusion-skeleton {
 width: 100%;
 height: 100%;
 margin-top: 20px;

 .skeleton-card {
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  &.primary-info {
   padding: 24px;
   height: 172px;
   background-color: rgba(22, 22, 22, 0.24);

   .title {
    height: 24px;
    width: 36%;
    border-radius: 24px;
    background-color: rgba(254, 254, 254, 0.32);
    margin-bottom: 4px;
   }

   .message-row {
    margin-top: 12px;
    width: 100%;
    height: 20px;
    border-radius: 4px;
    background-color: rgba(254, 254, 254, 0.24);
   }
  }

  &.secondary-info {
   height: 76px;
   background-color: #e6e6e6;
   flex-direction: row;
   margin: 8px 0;
   padding: 18px 16px;

   .fake-img {
    width: 40px;
    height: 40px;
    border-radius: inherit;
    background-color: rgba(22, 22, 22, 0.08);
    margin-right: 10px;
   }

   .info-wrapper {
    display: flex;
    flex: 1;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    background-color: transparent!important;

    .info {
     width: 40%;
     height: 16px;
     background-color: rgba(22, 22, 22, 0.08);
     border-radius: 4px;

     &:nth-child(2) {
      width: 77%;
      height: 20px;
     }
    }
   }
  }
 }

 .text-small-row {
  width: 56%;
  height: 16px;
  border-radius: 4px;
  background-color: #e6e6e6;
  margin-top: 24px;
 }
}

.pulse * {
 animation: pulse 1s infinite ease-in-out;
}

.wave * {
 animation: wave 1s infinite linear forwards;
 background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%) 800px 104px;
}

@keyframes pulse {
 0% {
  background-color: rgba(165, 165, 165, 0.1);
 }

 50% {
  background-color: rgba(165, 165, 165, 0.3);
 }

 100% {
  background-color: rgba(165, 165, 165, 0.1);
 }
}

@keyframes wave {
 0% {
  background-position: -468px 0
 }

 100% {
  background-position: 468px 0
 }
}
</style>
